import { hexToWorld, parseHexKey, worldToHex, type CampaignState } from '@somnhold/sim';

/**
 * Where the armory's rack stands (docs/EQUIPO.md §6): beside the forge, on the first spot around it whose cell is
 * free, the table camera's side first (in front, then the sides, then behind). Sim units.
 */
const ARMERO_SPOTS: [number, number][] = [[-330, 520], [330, 520], [-600, 0], [600, 0], [-330, -520], [330, -520]];
export const armeroSpot = (s: CampaignState, forgeKey: string): { x: number; y: number } => {
  const f = parseHexKey(forgeKey);
  const c = hexToWorld(f.q, f.r);
  for (const [dx, dy] of ARMERO_SPOTS) {
    const h = worldToHex(c.x + dx, c.y + dy);
    const k = `${h.q},${h.r}`;
    if (k !== forgeKey && !s.cells[k]?.built && !s.cells[k]?.job && !(h.q === 0 && h.r === 0)) return { x: c.x + dx, y: c.y + dy };
  }
  return { x: c.x + (ARMERO_SPOTS[0] as [number, number])[0], y: c.y + (ARMERO_SPOTS[0] as [number, number])[1] };
};
